<template>
  <div
    class="d-flex money-spinner"
    :class="[className, small ? 'size-small' : 'size-large']"
    :aria-label="ariaLabel"
  >
    <v-btn
      :disabled="valueLocal === config.min"
      :ripple="ripple"
      color="#7c869a"
      class="elevation-0 white--text"
      :data-uiid="minusDataUiid"
      @click="decrement()"
      aria-label="Decrement value"
    >
      <v-icon>mdi-minus</v-icon>
    </v-btn>
    <div
      class="d-flex text-center pa-1 pr-2 content flex-grow-1 justify-center align-center"
    >
      <v-money-spinner
        :data-uiid="inputDataUiid"
        @change="getVSpinnerValue"
        v-model="valueLocal"
        v-bind="config"
        disabled
        :dataUiid="dataUiid"
      ></v-money-spinner>
    </div>
    <v-btn
      :disabled="valueLocal === config.max"
      :ripple="ripple"
      color="#7c869a"
      class="elevation-0 white--text"
      :data-uiid="plusDataUiid"
      @click="increment()"
      aria-label="Increment value"
    >
      <v-icon>mdi-plus</v-icon>
    </v-btn>
  </div>
</template>

<script>
export default {
  props: {
    className: String,
    minusDataUiid: String,
    plusDataUiid: String,
    inputDataUiid: String,
    value: Number,
    config: Object,
    ripple: {
      type: Boolean,
      default: true,
    },
    type: {
      type: String,
      default: "number",
    },
    small: {
      type: Boolean,
      default: false,
    },
    dataUiid: String,
    ariaLabel: String,
  },
  data() {
    return {
      mouseEventDetectorInterval: null,
      valueChangeSpeed: 50,
      valueChangeSpeedInterval: null,
      valueLocal: null,
    };
  },
  created() {
    if (this.value) {
      this.valueLocal = this.value;
    }
  },
  watch: {
    value(val) {
      if (val !== this.valueLocal) {
        this.valueLocal = val;
      }
    },
  },
  methods: {
    increment() {
      if (!this.valueLocal) this.valueLocal = 0;
      if (
        this.valueLocal >= this.config.max ||
        this.valueLocal + this.config.step > this.config.max
      )
        return;
      this.valueLocal += this.config.step;
      this.valueLocal =
        Math.round((this.valueLocal + Number.EPSILON) * 100) / 100;
    },
    decrement() {
      if (!this.valueLocal && this.valueLocal !== 0) this.valueLocal = 0;
      if (this.valueLocal <= this.config.min) return;
      this.valueLocal -= this.config.step;
      this.valueLocal =
        Math.round((this.valueLocal + Number.EPSILON) * 100) / 100;
    },
    getVSpinnerValue(unformattedValue) {
      if (unformattedValue < 0) {
        this.valueLocal = 0;
        return;
      }
      this.$emit("input", unformattedValue);
    },
  },
};
</script>

<style lang="scss" scoped>
.content {
  border-top: 1px solid #7c869a;
  border-bottom: 1px solid #7c869a;
  box-sizing: border-box;
}

.pends {
  width: 20%;
  font-weight: bold;
  margin-top: 2px;
  font-size: 17px;
}

.money-spinner {
  background: white;
}

.money-spinner .v-btn:first-child {
  border-bottom-right-radius: 0 !important;
  border-top-right-radius: 0 !important;
}
.money-spinner .v-btn:last-child {
  border-bottom-left-radius: 0 !important;
  border-top-left-radius: 0 !important;
}

.money-spinner .v-btn:disabled {
  background-color: var(--v-powderlilac-base) !important;
  border: solid 1px var(--v-webgrey-base);
  cursor: not-allowed;
  pointer-events: all !important;
}

.money-spinner .v-btn:disabled * {
  color: #fff !important;
}

:deep(input:focus) {
  outline: none;
}
:deep(input) {
  display: flex;
  flex-grow: 1;
  font-size: 20px;
  font-weight: bold;
  width: 100%;
  color: $black-2 !important;
  -webkit-text-fill-color: $black-2 !important;
  opacity: 1 !important;
}

.size-small {
  :deep(input) {
    font-size: 20px;
  }

  :deep(.v-btn) {
    min-width: 48px !important;
    max-width: 48px !important;
    min-height: 48px !important;
  }
}

.size-large {
  .v-btn {
    min-width: 64px !important;
    min-height: 60px !important;
  }

  :deep(input) {
    font-size: 24px;
  }
}
.v-money {
  color: $black-2;
}
</style>
